import React, { CSSProperties, useEffect } from "react";
import { colors } from "../../Styles"
import { useTranslation } from "react-i18next";

interface Overlay_Props {
  content?: JSX.Element
  onClick?: () => void
  onClickAlert?: boolean // OBS: Should not be used in combination with unique onClick event
  beforeUnload?: boolean
  overrides?:{
    genericStyle?: CSSProperties
    color?: string
    zIndex?: number
    blur?: boolean
    alertMessage?: string
  }
}

export default function Overlay({ content, onClickAlert=false, beforeUnload=false, onClick, overrides }:Overlay_Props) {
  const {t} = useTranslation();

  useEffect(() => {
    if (!beforeUnload) return;
    
    const unloadCallback = (event: { preventDefault: () => void; returnValue: string; }) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };
  
    window.addEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, []);

  return (
    <div onClick={() => onClickAlert ? alert(overrides&&overrides.alertMessage ? overrides.alertMessage : t("saveAlert", {defaultValue: "Please save or cancel edit view."})) : onClick} style={{ 
      backgroundColor: overrides&&overrides.color ? overrides.color : colors.blackPrimary+"cc", 
      zIndex: overrides&&overrides.zIndex ? overrides.zIndex : 999,
      position: "absolute", 
      top: 0, 
      left: 0, 
      bottom: 0, 
      right: 0,
      backdropFilter: overrides&&overrides.blur ? "blur(1px)" : "none",
      ...overrides&&overrides.genericStyle
    }}>
      {content}
    </div>
  )
}